<div class="p-2 page-height overflow-auto bg-panel">
  <div class="page-container">
    <mat-card class="rounded-md">
      <mat-card-content class="text-center">
        <h4 class="mb-1" data-test="settings-page-title">{{ pageTitle }}</h4>
        <p class="text-muted small mb-3">Manage the configuration for this business unit.</p>
        <div class="hr-light mb-4"></div>

        <div class="settings-tile-grid">
          @for (card of cards; track card.route) {
            <button
              type="button"
              class="settings-tile rounded-md border border-light border-1 text-start"
              [attr.data-test]="card.testId"
              (click)="open(card)"
            >
              <div class="settings-tile-icon mon-text-primary">
                <fa-icon [icon]="card.icon" size="lg"></fa-icon>
              </div>
              <div class="settings-tile-body">
                <h5 class="mb-1">{{ card.title }}</h5>
                <p class="text-muted small mb-0">{{ card.description }}</p>
              </div>
              <mat-icon class="settings-tile-chevron text-muted">chevron_right</mat-icon>
            </button>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
